module.exports = __webpack_public_path__ + "e186e4610a7fe40e623ae49445c10c4c.MP3";